import React, { useContext, useEffect, useState } from 'react';
import { inject, observer } from "mobx-react";
import ym from 'react-yandex-metrika';
import { BRANDS, checkSpecificGetParam, fieldValidator, getLang, transformPhoneNumber } from '../../../common';
import { dispatchCheckPhone, dispatchPromoCode, dispatchCheckEmail } from '../../../api/Registration/api';
import RegWrapper from './RegWrapper';
import LoadingSpinner from '../../ui/loadingSpinner';
import RegForm from './RegForm';
import RegFormRow from './RegFormRow';
import Alert from '../../ui/alert';
import PhoneSelect from './PhoneSelect';
import EmailInput from './EmailInput';
import CurrencySelect from './CurrencySelect';
import PasswordInput from './PasswordInput';
import PromoInput from './PromoInput';
import Button from '../../ui/btn';
import { RegContext } from "./RegContext";
import debounce from 'lodash/debounce';
import { resSuccess, resError } from "./utils/constants";
import {
	logForOpenRegForm,
	logForEnteredCharInRegForm,
	logForRegButtonEnter,
	logForChangeСurrency,
	logForSelectCountry
} from "../../../logger/loggerRegForm";

const Step1 = inject('appStore', 'kafkaStore')(observer((props) => {
	const {
		kafkaStore: {
			imprintHash
		},
		brandName,
		lang,
		langId,
		translationForReg,
		countryData,
		currencyData,
		prevData,
		token,
		defaultCountryId,
		defaultCurrencyId,
		defaultPromoCode,
		regFormTitle,
		currencyId,
		landingName,
		regWith = 'phone',

	} = props;

	const [wait, setWait] = useState(true);
	const [country, setCountry] = useState(null);
	const [phone, setPhone] = useState(null);
	const [email, setEmail] = useState(null);
	const [regType, setRegType] = useState(regWith);
	const [charInputCounter, setCharInputCounter] = useState(0);
	const [currency, setCurrency] = useState(null);
	const [currencyList, setCurrencyList] = useState([]);
	const [password, setPassword] = useState('');
	const [promocode, setPromocode] = useState(defaultPromoCode);
	const [prevailingPromocode, setPrevailingPromocode] = useState('');
	const [listCounter, setListCounter] = useState(0);
	const [time, setTime] = useState(0);
	const [errorMessages, setErrorMessages] = useState({
		phone: '',
		password: '',
		promocode: '',
		formError: '',
		email: '',
	});

	// const regByPhone = 'phone';

	const { updateData } = useContext(RegContext);

	useEffect(() => {
		// setRegType(regByPhone);
		setCurrencyList(currencyData);
		logForOpenRegForm(imprintHash);
		setPrevailingPromocode(checkSpecificGetParam('promo_code'));
	}, []);

	useEffect(() => {
		if (country) {
			setPhone(country.phone_code);

			const newCurrencyList = currencyData.filter(element => country.currency.available.find(id => id === element.id));

			setCurrencyList(newCurrencyList);
			if (newCurrencyList) {
				setCurrency(newCurrencyList.find(el => el.id === country.currency.default))
			}

		}
	}, [country]);

	useEffect(() => {
		setData();
	}, [defaultCountryId, defaultCurrencyId, prevData])

	useEffect(() => {
		if (prevData.promocode) {
			// setWait(false)
			return
		}
		if (defaultPromoCode) {
			setDefaultPromoCode(defaultPromoCode)
		}
		// setWait(false)
	}, [currency])


	/**
	 * Объявляю в state дефолтные значения (country, currency, promoCode), если они есть.
	 */
	const setData = async () => {
		if (prevData) {
			setCountry(prevData.country);
			setPhone(prevData.phone);
			setEmail(prevData.email);
			setCurrency(prevData.currency);
			setPassword(prevData.password);
			setPromocode(prevData.promocode);
			setWait(false)
			return
		}

		const countrySetter = setDataCountry(defaultCountryId);
		const currencySetter = setDataCurrency(defaultCurrencyId);

		setWait(false);

		if (!countrySetter || !currencySetter) {
			setErrorMessages({
				...errorMessages,
				formError: getLang(translationForReg, brandName, lang, 'serverErr')
			})
		}
	}

	/**
	 * Обработка ошибок request
	 * @param error
	 * @param type
	 */
	const requestError = (error, type) => {
		if (error.key?.length > 0) {
			setErrorMessages({
				...errorMessages,
				[type]: error.text
			})
		} else {
			setErrorMessages({
				...errorMessages,
				[type]: error.text
			})
		}
	}

	/**
	 * Задаю country по дефолту,
	 * @param {Number} defaultCountryId передается в главный компонент пропсами.
	 * По умолчанию всегда Россия!
	 */
	const setDataCountry = (defaultCountryId) => {

		const defaultValue = countryData.find(item => brandName === BRANDS.zenbet ? item.country_id === "124" : item.country_id === "643");
		if (!countryData) return false;
		if (defaultCountryId) {
			const find = countryData.find(item => item.country_id == defaultCountryId);
			if (!find) {
				setCountry(defaultValue)
			}
			setCountry(find)
			setPhone(find.phone_code)
		} else {
			setCountry(defaultValue)
		}
		return true
	}

	/**
	 * Задаю country по дефолту,
	 * @param {Number} defaultCurrencyId передается в главный компонент пропсами.
	 * По умолчанию всегда Рубль!
	 */
	const setDataCurrency = (defaultCurrencyId) => {
		const countryByDefault = countryData.find(item => item.country_id == defaultCountryId);
		const currencyAvailable = currencyData.filter(item => countryByDefault.currency.available.find(element => item.id === element));

		if (brandName === BRANDS.zenbet) {
			setCurrencyList(currencyAvailable);
		} else {
			setCurrencyList(Object.values(currencyData));
		}

		if (!defaultCurrencyId) {
			defaultCurrencyId = countryByDefault.currency.default
		}

		if (!currencyData) return false;
		if (defaultCurrencyId) {
			const find = Object.values(currencyData).find(item => item.id == defaultCurrencyId)
			if (!find) {
				setCurrency(currencyData[0]);
			}
		} else {
			setCurrency(currencyData[0]);
		}
		return true
	}

	/**
	 * Проверка промокода с возвратом ошибки
	 * (подходит для проверки промокода по дефолту, ошибка по партнерскому промокоду выводится только в консоль)
	 * @param {String} promoCode промокод для проверки
	 * @returns {boolean}
	 */

	/**
	 * Задаю промокод по дефолту,
	 * @param {String} defaultPromoCode передается в главный компонент пропсами
	 * @returns {boolean}
	 */
	const setDefaultPromoCode = async (defaultPromoCode) => {
		if (!currency) return;
		if (defaultPromoCode.length === 0) return;

		if (prevailingPromocode) {
			const responsePrevailingPromocode = await checkPromoCode(prevailingPromocode);
			if (responsePrevailingPromocode?.status === 200) {
				if (responsePrevailingPromocode?.data?.code === 0) {
					setPromocode(prevailingPromocode)
				} else {
					await checkPromoCode(defaultPromoCode);
				}
			}
		} else {
			await checkPromoCode(defaultPromoCode);
		}
	}

	const onSelectCountry = (item) => {
		setPhone(item.phone_code);
		setCountry(item);
	};

	const onSetCounter = () => {
		setListCounter(listCounter + 1);
	}

	const logEnteredChars = (inputCharString) => {
		const inputCharSetArr = inputCharString.split('(');
		if (inputCharString.length > 1 && inputCharSetArr) {
			if (inputCharSetArr[1] && inputCharSetArr[1].length === 1) {
				logForEnteredCharInRegForm(regType, imprintHash);
			}
		}
	}


	const onPhoneInput = (item) => {
		const countNum = window.location.hostname === 'localhost' ? 3 : 4; // из-за особенностей отработки Input Mask OnAccept

		if (charInputCounter === countNum) {
			logEnteredChars(item);
		}

		setCharInputCounter(charInputCounter + 1);

		if (errorMessages.phone) {
			setErrorMessages({
				...errorMessages,
				phone: null,
			});
		}
		setPhone(item);
	};

	const onSelectCurrency = (item) => {
		setErrorMessages({
			...errorMessages,
			promocode: '',
		});

		setErrorMessages({
			...errorMessages,
			formError: ''
		})

		setCurrency(item);
		logForChangeСurrency(item.id, imprintHash)
	};

	const onPasswordInput = (e) => {
		const value = e.target.value;
		setPassword(value);
		if (fieldValidator(value, {
			latinNumber: true,
			minLength: 6,
			maxLength: 30,
		}).isValid || value.length === 0) {
			setErrorMessages({
				...errorMessages,
				password: null,
			});
		} else {
			setErrorMessages({
				...errorMessages,
				password: getLang(translationForReg, brandName, lang, 'passwordLengthErr')
			});
		}
	};

	const onEmailInput = (e) => {
		const value = e.target.value;
		setEmail(value);

		if (charInputCounter === 0) {
			if (value.length === 1) {
				logForEnteredCharInRegForm(regType, imprintHash);
			};
		}

		setCharInputCounter(charInputCounter + 1);
	}

	const checkPromoCode = async (value) => {
		const formData = new FormData();
		formData.append('promo_code', value);
		formData.append('currency_id', currency?.id);
		const response = await dispatchPromoCode(formData);
		if (response.data.code === 0) {
			setErrorMessages({
				...errorMessages,
				promocode: '',
			});
		}
		if (response.data.code === 1) {
			setErrorMessages({
				...errorMessages,
				promocode: response.data.text,
			});
		}
		return response
	};

	const debouncedCheckPromoCode = debounce(checkPromoCode, 1000);

	const onPromoCodeInput = (event) => {
		const value = event.target.value;
		const alphanumericRegex = /^[a-zA-Z0-9_]*$/;
		if (alphanumericRegex.test(value)) {
			setPromocode(value);
			debouncedCheckPromoCode(value);
		}
	};


	const checkPhone = async () => {
		const data = {
			country,
			currency,
			password,
			phone,
			promocode,
			email,
			token
		};

		const response = await dispatchCheckPhone(data)
		if (response.data.code === 1) {
			requestError(response.data, 'phone')
			// return false
		}

		return response;
	};

	const checkEmail = async () => {
		const data = {
			country,
			currency,
			password,
			phone,
			promocode,
			email,
			token
		};

		const response = await dispatchCheckEmail(data)
		if (response.data.code === 1) {
			requestError(response.data, 'email')
			// return false
		}

		return response;
	};

	const logRegButtonEnter = (regType, value, countryId, currencyId, promocode, result, error, imprint) => {
		value = transformPhoneNumber(value);
		logForRegButtonEnter(regType, value, countryId, currencyId, promocode, result, error, imprint)
	}

	useEffect(() => {
		if (listCounter >= 2) {
			if (time > 0) {
				if (country && country.country_id !== defaultCountryId) {
					logForSelectCountry(imprintHash, country.country_id, time, defaultCountryId)
				} else {
					logForSelectCountry(imprintHash, defaultCountryId, time)
				}
			}
			setTime(0);
			setListCounter(0);
		}
	}, [country, listCounter])

	const onSubmitHandlerIfPhone = async (e) => {
		e.preventDefault();

		if (!fieldValidator(phone, {
			minLength: 6,
			maxLength: 18,
		}).isValid) {
			setErrorMessages({
				phone: getLang(translationForReg, brandName, lang, 'phoneNumberErr'),
			});
			return null;
		}

		if (!fieldValidator(password, {
			latinNumber: true,
			minLength: 6,
			maxLength: 30,
		}).isValid) {
			setErrorMessages({
				password: getLang(translationForReg, brandName, lang, 'passwordLengthErr'),
			});
			return null;
		}

		const sendPhone = await checkPhone();

		logRegButtonEnter(regType, phone, country.country_id, currency.id, promocode,
			sendPhone.data.code === 1 ? resError : resSuccess,
			sendPhone.data.code === 1 && { code: sendPhone.data.code, message: sendPhone.data.text },
			imprintHash
		);

		let sendPromocode;

		if (promocode && promocode.length > 0) {
			const result = await checkPromoCode(promocode)
			if (result?.status !== 200) {
				setErrorMessages({
					...errorMessages,
					promocode: `Error: ${result?.status} ${result?.statusText}`
				})
				return null
			}

			if (result?.data?.code === 0) {
				ym('reachGoal', 'toStep2')
				if (errorMessages.promocode) {
					setErrorMessages({
						...errorMessages,
						promocode: ''
					})
					sendPromocode = true;
				}
			} else if (result?.data?.code === 1) {
				setErrorMessages({
					...errorMessages,
					promocode: result?.data.text
				})
				sendPromocode = false;
			}
		}

		if (sendPhone.data.code === 1 || (promocode?.length > 0 && sendPromocode)) {
			return null;
		}

		updateData({
			formData: {
				country,
				phone,
				currency,
				password,
				promocode,
			}, step: 2
		})
	};

	const onSubmitHandlerIfEmail = async (e) => {
		e.preventDefault();
		const emailValidation = /^[a-z'0-9]+([._-][a-z'0-9]+)*@([a-z0-9]+([._-][a-z0-9]+))+$/i.test(email);

		if (emailValidation !== true) {
			setErrorMessages({
				email: getLang(translationForReg, brandName, lang, 'emailLengthErr'),
			});
			return null;
		}

		if (!fieldValidator(password, {
			latinNumber: true,
			minLength: 6,
			maxLength: 30,
		}).isValid) {
			setErrorMessages({
				password: getLang(translationForReg, brandName, lang, 'passwordLengthErr'),
			});
			return null;
		}

		const sendEmail = await checkEmail();

		logRegButtonEnter(regType, email, country.country_id, currency.id, promocode,
			sendEmail.data.code === 1 ? resError : resSuccess,
			sendEmail.data.code === 1 && { code: sendEmail.data.code, message: sendEmail.data.text },
			imprintHash
		);

		let sendPromocode;

		if (promocode && promocode.length > 0) {
			const result = await checkPromoCode(promocode)
			if (result.status !== 200) {
				setErrorMessages({
					...errorMessages,
					promocode: `Error: ${result.status} ${result.statusText}`
				})
				return null
			}

			if (result.data.code === 0) {
				if (errorMessages.promocode) {
					setErrorMessages({
						...errorMessages,
						promocode: ''
					})
					sendPromocode = true;
				}
			} else if (result.data.code === 1) {
				setErrorMessages({
					...errorMessages,
					promocode: result.data.text
				})
				sendPromocode = false;
			}
		}

		if (sendEmail.data.code === 1 || (promocode?.length > 0 && sendPromocode)) {
			return null;
		}

		updateData({
			formData: {
				country,
				email,
				currency,
				password,
				promocode,
			}, step: 3
		})
	};

	if (wait) {
		return (
			<LoadingSpinner />
		);
	}

	const regWithPhone =
		<RegFormRow>
			<PhoneSelect
				className='PhoneCode'
				data={countryData}
				selectedCountry={country}
				value={phone}
				onSelect={onSelectCountry}
				onInput={onPhoneInput}
				label={getLang(translationForReg, brandName, lang, 'phoneLabel')}
				errorMessage={errorMessages.phone}
				searchInputPlaceholder={getLang(translationForReg, brandName, lang, 'search')}
				defaultCountryId={defaultCountryId}
				time={time}
				listCounter={listCounter}
				counter={onSetCounter}
				setTime={setTime}
			/>
		</RegFormRow>

	const regWithEmail =
		<EmailInput
			onInput={onEmailInput}
			value={email}
			errorMessage={errorMessages.email}
			label={getLang(translationForReg, brandName, lang, 'emailLabel')}
		/>

	return (
		<RegWrapper
			brandName={brandName}
			lang={lang}
			langId={langId}
			translationForReg={translationForReg}
			title={getLang(translationForReg, brandName, lang, 'formSubtitle')}
			subtitle
		>
			<RegForm>
				{wait ? <LoadingSpinner /> : null}
				<RegFormRow>
					{errorMessages.formError ?
						<Alert
							className='alert-danger'
							message={errorMessages.formError}
						/> : null
					}
				</RegFormRow>
				<div id="regType">
					{regType === 'phone' ? regWithPhone : regWithEmail}
				</div>
				<RegFormRow>
					<CurrencySelect
						options={currencyList}
						onSelect={onSelectCurrency}
						selectedCurrency={currency}
						label={getLang(translationForReg, brandName, lang, 'currencyLabel')}
					/>
				</RegFormRow>
				<RegFormRow>
					<PasswordInput
						onInput={onPasswordInput}
						value={password}
						errorMessage={errorMessages.password}
						label={getLang(translationForReg, brandName, lang, 'passwordLabel')}
					/>
				</RegFormRow>

				<RegFormRow>
					<PromoInput
						onInput={onPromoCodeInput}
						value={promocode}
						errorMessage={errorMessages.promocode}
						translationForReg={translationForReg}
						brandName={brandName}
						lang={lang}
						label={getLang(translationForReg, brandName, lang, 'promocodeLabel')}
					/>
				</RegFormRow>

				<RegFormRow>
					<Button id='toStep2' className='Registration' type='submit' onClick={regType === 'phone' ? onSubmitHandlerIfPhone : onSubmitHandlerIfEmail}>
						{getLang(translationForReg, brandName, lang, 'regButtonText')}
					</Button>
				</RegFormRow>
			</RegForm>
		</RegWrapper>
	);
}));

export default Step1;
